module.exports = __webpack_public_path__ + "static/media/yellow_pattern.7fc096c5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yellow_pattern.svg
// module id = 750
// module chunks = 0